(function () {
  if (customElements.get('wk-loader')) return;

  class WkLoader extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.productHandle = this.dataset.handle;
      this.wkItem = null;
      this.wlkButton = this.parentElement.querySelector('wishlist-button-collection');
      this.wlkLoaded = window.WishlistKing !== undefined;
      this.button = this.querySelector('.wk-loader-button');
      this.init();
    }

    init() {
      this.setupState();
      this.startUpWishlistKing();
    }

    setupState() {
      // this is fired in wishlist-queen.js that also updates the header wishlist state
      document.addEventListener('wk-wishlist-loaded', (data) => {
        if (data.detail) {
          const items = data.detail.items.filter((item) => {
            return item.productId == this.productId;
          });
          if (items.length) {
            this.wkItem = items[0];
            this.button.classList.add('selected');
            this.button.ariaLabel = window.theme.strings.wishlist.remove_label;
          }
        }
      }, { once: true });

      if (window.WishlistQueen && window.WishlistQueen.loaded) {
        document.dispatchEvent(new CustomEvent("wk-wishlist-loaded", { detail: window.theme.data.wishlist.mine }));
      }

      document.addEventListener('wk:app:loaded', async () => {
        this.wlkLoaded = true;
      });
    }

    async queryWishlistKing(selected) {
      if (selected) {
        await window.WishlistKing.removeWishlistItem({
          "productHandle": this.productHandle,
          "wishlistItemId": this.wkItem.id,
          "productId": this.wkItem.productId,
          "variantId": this.wkItem.variantId,
          "inWishlist": true
        }).then((data) => {
          if (!data) {
            this.button.classList.toggle('selected')
          }
        }).catch(() => this.button.classList.toggle('selected')).finally(() => { window.WishlistQueen.busy = false; });
      } else {
        await window.WishlistKing.addWishlistItem({
          "productHandle": this.productHandle,
          "wishlistItemId": null,
          "productId": this.productId,
          "variantId": this.variantId,
          "inWishlist": false
        }).then((data) => {
          if (!data) {
            this.button.classList.toggle('selected')
          }
          window.WishlistQueen.busy = false;
        }).catch(() => this.button.classList.toggle('selected')).finally(() => { window.WishlistQueen.busy = false; });;
      }
    }

    startUpWishlistKing() {
      // observe wishlist-button-collection added and remove wk-loader
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.tagName === 'WISHLIST-BUTTON-COLLECTION') {
              this.wlkButton = this.parentElement.querySelector('wishlist-button-collection');
              this.wlkLoaded = true;
              observer.disconnect();
            }
          });
        });
      });
      observer.observe(this.parentElement, {
        childList: true
      });

      this.button.addEventListener('click', () => {
        if (window.WishlistQueen.busy) return;
        window.WishlistQueen.busy = true;

        const selected = this.button.classList.contains('selected');
        // change visual state immediately, handle rest in background
        this.button.classList.toggle('selected');
        // label by reverse selected because this is still the state before the click
        this.button.ariaLabel = !selected ? window.theme.strings.wishlist.remove_label : window.theme.strings.wishlist.add_label;

        if (!this.wlkLoaded) {
          document.addEventListener('wk:app:ready', async () => {
            this.queryWishlistKing(selected);
          }, { once: true });
        } else {
          this.wlkButton.handleClick().then((data) => {
            if (!data) {
              this.button.classList.toggle('selected')
            }
          }).catch(() => this.button.classList.toggle('selected')).finally(() => { window.WishlistQueen.busy = false; });
        }

        if (window.TitusWkHelper) {
          window.TitusWkHelper.load();
        }
      });
    }
  }

  customElements.define('wk-loader', WkLoader);
})();